import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
let ApplicationTableColumnMappingService = class ApplicationTableColumnMappingService {
    appTableColumnMap = new BehaviorSubject(null);
    appTableItems = new BehaviorSubject(null);
    appTableColumnMapObservable = this.appTableColumnMap.asObservable();
    appTableItemsObservable = this.appTableItems.asObservable();
    constructor() {
    }
    setTableColumnMap(tableColumnMap) {
        this.appTableColumnMap.next(tableColumnMap);
    }
    setTableItems(tableItems) {
        this.appTableItems.next(tableItems);
    }
    static ctorParameters = () => [];
};
ApplicationTableColumnMappingService = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationTableColumnMappingService);
export { ApplicationTableColumnMappingService };
